import { render, staticRenderFns } from "./CommodityUnit.vue?vue&type=template&id=5ea47bd2&scoped=true"
import script from "./CommodityUnit.vue?vue&type=script&lang=js"
export * from "./CommodityUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea47bd2",
  null
  
)

export default component.exports